module.exports = require("core-js/modules/es.string.ends-with.js");